import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HolAndMessageService {
  constructor(private http: HttpClient) {}

  getHandOverLogs(reqBody?: any, params?: any) {
    return this.http.post(`/api/hand_over_log/list_data/`, reqBody, {
      params: params,
    });
  }
  getHandOverLogRelatedPatrolEvents(reqBody?: any, params?: any) {
    return this.http.post(`/api/hand_over_log/list_patrol_events/`, reqBody, {
      params: params,
    });
  }
  getHandOverLogRelatedNonPatrolEvents(reqBody?: any, params?: any) {
    return this.http.post(`/api/hand_over_log/list_other_events/`, reqBody, {
      params: params,
    });
  }
  createHandOverLog(body?: any, params?: any) {
    return this.http.post(`/api/hand_over_log/`, body, {
      params: params,
    });
  }
  updateHolNote(body?: any, params?: any) {
    return this.http.post(`/api/hand_over_log/update_hol_note/`, body, {
      params: params,
    });
  }

  retrieveHandOverLog(id: string, params?: any) {
    return this.http.get(`/api/hand_over_log/${id}/`, {
      params: params,
    });
  }

  // internal-messaging apis
  getConversationMessages(params: any) {
    return this.http.get('/api/gt_message/', { params: params });
  }
  sendMessage(body: any, params?: any) {
    return this.http.post('/api/gt_message/', body, { params: params });
  }
  manageMessage(id: any, body: any, params?: any) {
    return this.http.put(`/api/gt_message/${id}/`, body, { params: params });
  }
  manageMessageGroup(body?: any, params?: any) {
    return this.http.post(`/api/gt_message/manage_message_group/`, body, {
      params: params,
    });
  }
  manageMessageConversation(body?: any, params?: any) {
    return this.http.post(
      `/api/gt_message/manage_message_conversation/`,
      body,
      {
        params: params,
      },
    );
  }
  updateHOLDraftCount(count: any) {
    if (count) {
      sessionStorage.setItem('handOverLogDraftCount', count);
    } else {
      sessionStorage.removeItem('handOverLogDraftCount');
    }
  }
  // pinned-message apis
  async createPinnedMessage(body?: any, params?: any) {
    return lastValueFrom(
      this.http
        .post(`/api/pinned_message/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
  getPinnedMessages(params?: any) {
    return this.http
      .get(`/api/pinned_message/`, { params: params })
      .pipe(map((response: any) => response));
  }
  getPinnedMessageDetail(id: string, params?: any) {
    return this.http
      .get(`/api/pinned_message/${id}/`, { params: params })
      .pipe(map((response: any) => response));
  }
  async updatePinnedMessage(id: string, body?: any, params?: any) {
    return lastValueFrom(
      this.http
        .put(`/api/pinned_message/${id}/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
}
